module.exports = __webpack_public_path__ + "static/media/Blood & Gold_Production_FINAL_MIDRES_WEB-4096.dfe41903.jpg";